function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "DESKTOP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "2.2.---Kalkulator-zu\u017Cycia-wody",
  transform: "translate(-1165.000000, -382.000000)"
}, React.createElement("rect", {
  fill: "none",
  x: 0,
  y: 0,
  width: 1920,
  height: 1020
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "none",
  x: 0,
  y: 296,
  width: 1920,
  height: 724
}), React.createElement("g", {
  id: "produkcja",
  transform: "translate(1095.000000, 330.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("g", {
  id: "ico/ceny/wieprzowina",
  transform: "translate(70.000000, 52.303371)",
  fill: "#9B9B9B"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M40.46875,8.75 C55.5702861,8.75 67.8125,20.9922139 67.8125,36.09375 C67.8125,51.1952861 55.5702861,63.4375 40.46875,63.4375 C38.2067403,63.4375 36.0088825,63.1628329 33.9067091,62.6450311 C31.8043129,63.162746 29.6061176,63.4375 27.34375,63.4375 C12.2422139,63.4375 0,51.1952861 0,36.09375 C0,20.9922139 12.2422139,8.75 27.34375,8.75 C29.6061176,8.75 31.8043129,9.02475401 33.9067886,9.54271469 C36.0088825,9.0246671 38.2067403,8.75 40.46875,8.75 Z M27.34375,10.9375 C13.4503368,10.9375 2.1875,22.2003368 2.1875,36.09375 C2.1875,49.9871632 13.4503368,61.25 27.34375,61.25 C28.0772405,61.25 28.803399,61.218608 29.5209553,61.1570943 C19.8687469,56.9353683 13.125,47.3021024 13.125,36.09375 C13.125,24.8857838 19.8682822,15.2527956 29.5190659,11.0305659 C28.8027248,10.9688629 28.0769,10.9375 27.34375,10.9375 Z M40.46875,10.9375 C39.7358468,10.9375 39.010264,10.9688417 38.2932685,11.030258 C47.9442178,15.2527956 54.6875,24.8857838 54.6875,36.09375 C54.6875,47.3021024 47.9437531,56.9353683 38.2924364,61.1573706 C39.0095881,61.2186291 39.7355055,61.25 40.46875,61.25 C54.3621632,61.25 65.625,49.9871632 65.625,36.09375 C65.625,22.2003368 54.3621632,10.9375 40.46875,10.9375 Z M33.9067177,11.8021891 L33.6535905,11.8715777 C23.0714682,14.8428882 15.3125,24.562217 15.3125,36.09375 C15.3125,47.7168203 23.1951386,57.4988018 33.9061245,60.3854031 C44.6175293,57.4985935 52.5,47.7166966 52.5,36.09375 C52.5,24.4708034 44.6175293,14.6889065 33.9067177,11.8021891 Z M33.5469443,30.625 C35.1326021,30.625 36.423165,31.9155629 36.423165,33.5012207 C36.423165,34.2840639 36.0041532,35.1569457 34.9873554,36.4195038 L34.6950914,36.7737243 L33.9157389,37.6742871 L35.5834456,37.6763563 L35.7705729,37.6997501 C36.1984681,37.8001277 36.5057731,38.1830342 36.5057731,38.6281738 C36.5057731,39.0371122 36.2459445,39.3936146 35.8563701,39.5284842 L35.6818452,39.5722229 L35.5036439,39.5837357 L31.545571,39.5797641 L31.3484578,39.5536006 C31.0481497,39.478883 30.8012661,39.2624327 30.6889968,38.9712874 C30.5707906,38.6647457 30.6199633,38.3238884 30.8065282,38.0676191 L30.9347143,37.9249593 L31.3844639,37.5017975 L31.939402,36.9539933 L32.3542796,36.5260336 L32.7522057,36.0974499 L33.0307483,35.784853 L33.5156528,35.207601 C33.5884037,35.1168669 33.6571059,35.0289192 33.7217362,34.9438318 L33.9033881,34.6972242 L34.1899639,34.2646845 C34.3722102,33.963856 34.4770735,33.7226515 34.5052311,33.6012521 C34.5022095,33.0446577 34.1702355,32.6329023 33.7334312,32.5478433 L33.5651533,32.5316153 L33.3461788,32.5449805 C32.9418436,32.6120418 32.6220337,32.9336665 32.5471959,33.3491596 L32.5071948,33.7196338 C32.4068173,34.147529 32.0239108,34.454834 31.5787711,34.454834 C31.0520718,34.454834 30.6250933,34.0278926 30.6250933,33.5012207 C30.6250933,32.1203178 31.6099474,30.9457394 32.9355021,30.680794 L33.2396004,30.6371738 L33.5469443,30.625 Z",
  id: "Combined-Shape"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "70px",
    height: "71px",
    viewBox: "0 0 70 71",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/obie.d24ae014.svg";
export { SvgComponent as ReactComponent };